
import React, {Component, PropTypes} from 'react'
import stylesDocCss from './../documents.scss'
import stylesPHolder from './popupOfSignaturePlaceholder.scss'
import Modal from 'react-modal'
import cs from 'classnames'
import nesProp from 'nested-property'
import i18n from 'lib/i18n'
import * as c from 'state/constants'
import {findDocumentFromListById, filterDocumentsByPackageId, isValidDocument} from './../DSWizardHelper'
import {packageDocumentsAttachIdCursor, packageDocumentsListUpdateByDocument} from './../DSWizardFormControl'
import {upsertDSDocumentAndFetchAllData} from '../../../state/actions'
import {connect} from 'react-redux'
import xss from 'xss'
import SignaturePlaceholderSelector from './signaturePlaceholderSelector'
import DynamicImageListComponent from './dynamicImageListComponent'
import ReactSelect2 from '../../../elements/ReactSelect2Wrapper'
import uuidv4 from 'uuid/v4'

// init translations
const _ = i18n('dswizard')
const PAGE_DISTANCES = 50 // in pixel

@connect(
    (state) => {
        return {

        }
    }
)
export default class PopupOfSignaturePlaceholder extends Component {
    static propTypes = {
        dataForEditDocument: PropTypes.any,
        packageDSDocuments: PropTypes.array,
        stakeholders: PropTypes.array,
        isOpen: PropTypes.bool,
        style: PropTypes.object,
        contentLabel: PropTypes.string,
        lang: PropTypes.string,
        dynamicFieldIdCursor: PropTypes.number,
        onCancel: PropTypes.func,
        onSave: PropTypes.func,
        didClose: PropTypes.func,
        setFieldIdCursor: PropTypes.func,
        getDocumentsFromStore: PropTypes.func,
        updatePackageDocuments: PropTypes.func,
        DSDocumentOriginTypes:  PropTypes.object
    }

    constructor(props) {
        super(props)

        this.scrollContainerRef = null
        this.scrollPositionX = 0
        this.scrollPositionY = 0
        this.scrollId = 0

        this.state = {placeholders: [], jumpersState: {}}
    }

    handleScroll = (e) => {
        this.scrollPositionY = e.currentTarget.scrollTop
        this.scrollPositionX = e.currentTarget.scrollLeft
        return e
    }

    setScrollContainerRef = (ref) => {
        this.scrollContainer = ref
    }

    componentDidUpdate(prevProps, prevState) {
        // placeholder handler
        const {dataForEditDocument, stakeholders} = this.props
        const dataForEditDocumentOld = prevProps.dataForEditDocument

        if (dataForEditDocument) {
            let dsDocument = dataForEditDocument.dsDocument
            let maxPageNumber = dataForEditDocument.maxPageNumber
            let pageSizeList = dataForEditDocument.pageSizeList

            // try to get old document from previous props
            let dsDocumentOld
            if (dataForEditDocumentOld && dataForEditDocumentOld.dsDocument) {
                dsDocumentOld = dataForEditDocumentOld.dsDocument
            }

            // init placeholder selector
            // detect if a new document is opened. The component is mounted, so we have to check the
            // opened document._id to know if another one is opened.
            if (dsDocument && dsDocument._id && (!dsDocumentOld || (dsDocument._id !== dsDocumentOld._id))) {
                let idForDOMElement = c.DSDOC_PLACEHOLDER_ELEMENT_REF + dsDocument._id

                // new instance of tool, require reset the scroll
                this.scrollPositionX = 0
                this.scrollPositionY = 0

                this.signaturePlaceholderSelector = new SignaturePlaceholderSelector(
                    stakeholders,
                    idForDOMElement,
                    maxPageNumber,
                    PAGE_DISTANCES,
                    pageSizeList,

                    // flushUpdates function provided for the coordinate selector tool
                    (placeholders) => {
                        return this.receivePlaceholder(placeholders)
                    }
                )
            }

            if (!prevProps.isOpen && this.props.isOpen) {
                // modal reopened, require reset the scroll
                this.scrollPositionX = 0
                this.scrollPositionY = 0

                // clear unwanted placeholders leaved in the tool instance
                this.signaturePlaceholderSelector.deleteAllPlaceholders()

                // reload placeholders
                let placeholders = dsDocument.signatureManualPlaceholders

                // reload already saved placeholders
                if (placeholders) {
                    let that = this
                    let deppCloneOfPlaceholders = JSON.parse(JSON.stringify(placeholders))

                    // set timeout to wait until render page.
                    let timeoutId = setTimeout(() => {
                        for (let i = 0; i < deppCloneOfPlaceholders.length; i++) {
                            that.signaturePlaceholderSelector.createSignaturePlaceholder(
                                deppCloneOfPlaceholders[i],
                                false,
                                (placeholder) => {
                                    //console.log("PLACEHOLDERS: ",this.signaturePlaceholderSelector.getPlaceholders())
                                },
                                true
                            )
                        }

                        clearTimeout(timeoutId);
                    }, 0)
                }
            }
        }
    }

    /**
     * This function will be fired in react component when the coordinate selector flush the changes.
     * @param {*} placeholders
     */
    receivePlaceholder(placeholders) {
        this.setState({placeholders}, () => {
             // scroll handler
            if (this.scrollContainer) {
                this.scrollContainer.scrollTop = this.scrollPositionY
                this.scrollContainer.scrollLeft = this.scrollPositionX
            }
        })
    }

    /**
     * This function will find the package Id in a ds document record, even if the packageId is a populated prop or mongoose model.
     * @param {*} dsDocument
     * @returns
     */
    getPackageIdFromDsDocument(dsDocument) {
        let packageId
        if (typeof dsDocument.packageId === "string") {
            packageId = dsDocument.packageId
        } else {
            if (typeof dsDocument.packageId === "object" && dsDocument.packageId._id) {
                packageId = dsDocument.packageId._id
            } else {
                // nothing to do
                packageId = dsDocument.packageId
                console.warn("No valid packageId is set for DsDocument in save-DocumentPlaceholders function.")
            }
        }

        return packageId
    }

    /**
     * This function will update a document in database when the placeholder are saved.
     * @param {*} dsDocument
     * @param {*} dsDocument
     * @param {*} totalNumberOfSigners
     * @returns
     */
    async saveDocumentPlaceholders(dsDocument, totalNumberOfSigners) {
        let {dispatch, lang, dynamicFieldIdCursor, setFieldIdCursor, getDocumentsFromStore,
            updatePackageDocuments, DSDocumentOriginTypes} = this.props

        let errorMessages = []
        let isValid = isValidDocument(dsDocument, totalNumberOfSigners, DSDocumentOriginTypes)

        if (!isValid) {
            errorMessages.push(
                _("signaturePlaceholdersAreNotSetCorrectly")
            )
        }

        let packageId = this.getPackageIdFromDsDocument(dsDocument)

        let updateThisValue = {
            _id: dsDocument._id,
            signatureManualPlaceholders: this.signaturePlaceholderSelector.getPlaceholders(),
            errorMessages: errorMessages
        }

        let updatedDocument = await dispatch(upsertDSDocumentAndFetchAllData({documentData: updateThisValue}))

        dynamicFieldIdCursor = 1

        // refresh state packageDSDocuments from props "documents" by packageId, because after
        // the API call of upsertDSDocumentAndFetchAllData the documents are reloaded in store
        let docsFromProps = getDocumentsFromStore()
        let packageDSDocuments = filterDocumentsByPackageId(docsFromProps, packageId)
        let attachIdResult = packageDocumentsAttachIdCursor(packageDSDocuments, dynamicFieldIdCursor, true)

        packageDSDocuments = attachIdResult.packageDSDocuments
        setFieldIdCursor(attachIdResult.dynamicFieldIdCursor)

        // add or overwrite the affected document in list of documents
        packageDSDocuments = packageDocumentsListUpdateByDocument(packageDSDocuments, updatedDocument) //sync

        await updatePackageDocuments(packageDSDocuments)

        // return final promise: resolved if template filled correctly else reject it.
        return updatedDocument
    }

    /**
     * Add new signature placeholder on iframe
     * @returns
     */
    startSelectCoordinate() {
        if (!this.signaturePlaceholderSelector) {
            return
        }

        // initial values, optional
        let placeholderRecord = {
            width: this.signaturePlaceholderSelector.MINIMUM_PLACEHOLDER_WIDTH_PTS, // 112, // -min width
            height: this.signaturePlaceholderSelector.MINIMUM_PLACEHOLDER_HEIGHT_PTS, // 70 // -min height
        }

        this.signaturePlaceholderSelector.createSignaturePlaceholder(
            placeholderRecord,
            true,
            (placeholder) => {
            //     console.log("Placeholder released!", placeholder)
            //     console.log(this.signaturePlaceholderSelector.getPlaceholders())
            }
        )
    }

    getBinIcon() {
        try {
            return require(`resources/images/icon-cancel.svg`)
        } catch(err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    getMoveIcon() {
        try {
            return require(`resources/images/a-open_with-gray.png`)
        } catch(err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    getResizeIcon() {
        try {
            return require(`resources/images/corner.svg`)
        } catch(err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    getJumpIcon() {
        try {
            return require(`resources/images/a-jump-ovbblue.svg`)
        } catch(err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    renderPlaceholder(placeholder, placeholders, stakeholders) {
        let stakeOptionsList = []
        let selectedSigner

        // add select options, must be recalculated in each render, because the option list is dynamic
        // depends on the already selected signers by other placeholders
        for (let i=0; i < stakeholders.length; i++) {
            let oneStake = stakeholders[i]
            let signerTypeSelectOpt = {}

            signerTypeSelectOpt.label = oneStake.firstName + " " + oneStake.lastName + " [" + oneStake.email + "]"
            signerTypeSelectOpt.value = oneStake._id

            // set selected the loaded value if exists
            if (placeholder.stakeholderId && String(placeholder.stakeholderId) === String(oneStake._id)) {
                signerTypeSelectOpt.selected = true
                selectedSigner = signerTypeSelectOpt
            }

            // checking if the current selectOption is selected by this placeholder, what is rendering by this function now
            let currentIdIsUsedByThisActualSelectInput = String(signerTypeSelectOpt.value) === String(placeholder.stakeholderId)

            // check the rest of the placeholders to filter the used options
            let canAddTheOptionToTheList = true

            // Do not check if someone is used because of BEWB-743 (vwrsion 8.2 recuirement)!!!
            // for (let j=0; j < placeholders.length; j++) {
            //     let onePlaceholder = placeholders[j]

            //     // checking the current selectOption, if already selected by some of the placeholders
            //     let currentIdIsAlreadyUsed = String(onePlaceholder.stakeholderId) === String(signerTypeSelectOpt.value)

            //     // the exclude condition for a selectOption of the actual dropdown
            //     if ( currentIdIsAlreadyUsed && !currentIdIsUsedByThisActualSelectInput ) {
            //         canAddTheOptionToTheList = false
            //     }
            // }

            // add option to the list if not already taken by other placeholder than this, or not selected by this select input
            if (canAddTheOptionToTheList) {
                stakeOptionsList.push(signerTypeSelectOpt)
            }
        }

        // prepare helper values to calculate coordinates and sizes
        let pageTop = this.signaturePlaceholderSelector.getPageTop(placeholder.placedOnPage)
        let xMultiplier = this.signaturePlaceholderSelector.getXMultiplier(placeholder)
        let yMultiplier = this.signaturePlaceholderSelector.getYMultiplier(placeholder)

        return (
            <div
                key={placeholder.id}
                id={placeholder.id}
                className={stylesPHolder.pHolderBody}
                style={{
                    width: (placeholder.width / xMultiplier)+"px",
                    height: (placeholder.height / yMultiplier)+"px",
                    left: (placeholder.x / xMultiplier)+"px",
                    top: ((placeholder.y / yMultiplier) + pageTop)+"px",
                }}
                draggable={false}
            >
                <div
                    key={placeholder.id + "remove_button"}
                    id={placeholder.id + "remove_button"}
                    className={cs(stylesPHolder.pHolderDotButton, stylesPHolder.buttonRemove)}
                    draggable={false}
                    onMouseDown={(e) => {
                        console.log("onMouseDownclicked")
                    }}
                    onClick={(e) => {
                        if (this.signaturePlaceholderSelector) {
                            this.signaturePlaceholderSelector.removeSignaturePlaceholder(placeholder.id)
                        }
                    }}
                >
                    <img
                        src={this.getBinIcon()}
                        className={stylesPHolder.buttonRemoveIcon}
                        draggable={false}
                        onDragStart={(e) => {
                            e.preventDefault()
                            return false
                        }}
                    />
                </div>

                <div
                    key={placeholder.id + "move_button"}
                    id={placeholder.id + "move_button"}
                    className={cs(stylesPHolder.pHolderDotButton, stylesPHolder.buttonMove)}
                    draggable={false}
                    onMouseDown={() => {
                        this.signaturePlaceholderSelector.moveStart(placeholder.id)
                    }}
                    onMouseUp={() => {
                        this.signaturePlaceholderSelector.moveStop()
                    }}
                >
                    <img
                        src={this.getMoveIcon()}
                        className={stylesPHolder.buttonMoveIcon}
                        draggable={false}
                        onDragStart={(e) => {
                            e.preventDefault()
                            return false
                        }}
                    />
                </div>

                <div
                    key={placeholder.id + "resize_button"}
                    id={placeholder.id + "resize_button"}
                    className={cs(stylesPHolder.pHolderDotButton, stylesPHolder.buttonResize)}
                    draggable={false}
                    onMouseDown={() => {
                        this.signaturePlaceholderSelector.resizeStart(placeholder.id)
                    }}
                    onMouseUp={() => {
                        this.signaturePlaceholderSelector.resizeStop()
                    }}
                >
                    <img
                        src={this.getResizeIcon()}
                        className={stylesPHolder.buttonResizeIcon}
                        draggable={false}
                        onDragStart={(e) => {
                            e.preventDefault()
                            return false
                        }}
                    />
                </div>

                <ReactSelect2
                    key={placeholder.id + "selectedSignerSelectInput"}
                    value={selectedSigner}
                    className={stylesPHolder.pHolderSelect}
                    openMenuOnFocus={true}
                    customStyles={{
                        menu: base => ({
                            ...base,
                            borderRadius: 2,
                            hyphens: "auto",
                            marginTop: 0,
                            textAlign: "left",
                            wordWrap: "break-word",
                            fontSize: "16px",
                            lineHeight: "16px",
                            height: "auto",
                            padding: "2px",
                            margin: "2px"
                        }),
                        menuList: base => ({
                            ...base,
                            padding: 0,
                            verticalAlign: "baseline",
                            backgroundColor: "rgba(255,255,255,1)",
                            height: "max-content"
                        }),
                        option: (base, state) => ({
                            ...base,
                            padding: 0,
                            fontSize: '0.80em',
                            maxHeight: "max-content"
                        }),
                    }}
                    draggable={false}
                    onDragStart={(e) => {
                        e.preventDefault()
                        return false
                    }}
                    onBlur={(e) => {
                        const {/* value, */ onChange} = this.props

                        if (onChange && typeof onChange === "function") {
                            onChange({label: e.target.value, value: e.target.value})
                        }

                        return e.target.value
                    }}
                    onChange={(value) => {
                        let thisPlaceholder = this.signaturePlaceholderSelector.getPlaceholderByIdFromList(placeholder.id)

                        let alreadyUsedSigners = this.signaturePlaceholderSelector._placeholders.map((item) => {
                            return item.stakeholderId
                        })

                        // prevent to select a value what is selected by others
                        //if (alreadyUsedSigners.indexOf(newSelectedValue) == -1) {
                            thisPlaceholder.stakeholderId = value.value

                            // notify the tool about change
                            this.signaturePlaceholderSelector.updateSignaturePlaceholder(placeholder)

                        //} else {

                            // avoid to change
                        //    e.preventDefault();
                        //}

                    }}
                    options={stakeOptionsList}
                    placeholder={_("pleaseSelectASigner")}
                    onBlurResetsInput={false}
                />

                <span
                    key={placeholder.id + "page_number_text_holder"}
                    id={placeholder.id + "page_number_text_holder"}
                    className={stylesPHolder.pageNumberHolderTextContainer}
                    draggable={false}
                >
                    {_("pageNumberOfPlaceholder")}
                    <span
                        key={placeholder.id + this.signaturePlaceholderSelector.ELEMENT_ID_POSTFIX_FOR_PAGE_NUMBER_VALUE}
                        id={placeholder.id + this.signaturePlaceholderSelector.ELEMENT_ID_POSTFIX_FOR_PAGE_NUMBER_VALUE}
                        className={stylesPHolder.pageNumberHolderText}
                        draggable={false}
                    >
                        {placeholder.placedOnPage + "/" + this.signaturePlaceholderSelector._totalPageNumber}
                    </span>
                </span>
            </div>
        )
    }

    /**
     * Render a jumper button to jump to the placeholder
     * @param {*} placeholder
     * @param {*} placeholdersMap
     * @returns
     */
    renderPlaceholderJumpers (placeholder, placeholdersMap) {
        const { stakeholders } = this.props
        const { jumpersState } = this.state

        let usedXTimes = jumpersState && jumpersState[placeholder.stakeholderId] ? jumpersState[placeholder.stakeholderId] : 0
        let samePholders = placeholdersMap[placeholder.stakeholderId]
        let indexOfThisPlaceholder = 0

        for (let i = 0; i < samePholders.length; i++) {
            if (samePholders[i].id === placeholder.id) {
                indexOfThisPlaceholder = i
                break
            }
        }

        let renderOnlyOnIndex = usedXTimes % samePholders.length

        // skip if not the right index by incremental counter
        if (indexOfThisPlaceholder !== renderOnlyOnIndex) {
            return (<div key={"nothing_to_render"+placeholder.id}></div>)
        }

        let signerName = ""
        let signerAddress = ""

        // add select options
        for (let i=0; i < stakeholders.length; i++) {
            let oneStake = stakeholders[i]

            if (String(placeholder.stakeholderId) === String(oneStake._id)) {
                signerName = oneStake.firstName + " " + oneStake.lastName
                signerAddress = oneStake.email
            }
        }


        if (!signerAddress) {
            return (<div key={"nothing_to_render"+placeholder.id}></div>)
        }

        return (
            <div
                key={placeholder.id+ "_jumper_button_key"}
                id={placeholder.id + "_jumper_button"}
                className={stylesPHolder.jumpButton}
                draggable={false}
                onClick={(e) => {
                    this.scrollId = uuidv4()

                    this.increaseJumperIndex(placeholder)

                    this.scrollTo(placeholder, this.scrollId)
                }}
            >
                <div
                    className={stylesPHolder.jumpButtonText}
                    key={placeholder.id + "JumperButtonNameKey"}>
                    {signerName}
                </div>
                {/*<div className={stylesPHolder.jumpButtonText}>{signerAddress}</div>*/}
                <div
                    className={stylesPHolder.jumpButtonIconHolder}
                    key={placeholder.id + "JumperIconNameKey"}
                >
                    <img
                            src={this.getJumpIcon()}
                            className={stylesPHolder.jumpButtonIcon}
                            style={{
                                display: "block",
                                pointerEvents: "none",
                                userSelect: "none"
                            }}
                            draggable={false}
                            onDragStart={(e) => {
                                e.preventDefault()
                                return false
                            }}
                    />
                </div>
            </div>)
    }

    /**
     * Lerp scroll to signature placeholder
     * @param {*} placeholder
     * @param {*} scrollId - In case of new scroll started, the old scroll lerp thread must be killed. This id let to check himself in recursion to kill it or not.
     */
    scrollTo(placeholder, scrollId, lastX = -1, lastY = -1) {
        let that = this
            let timeoutId = setTimeout(() => {
                if (!that.scrollContainer) {
                    return
                }

                // calc the target
                var limitY = Math.max(that.scrollContainer.scrollHeight, that.scrollContainer.offsetHeight);
                var limitX = Math.max(that.scrollContainer.scrollWidth, that.scrollContainer.offsetWidth);
                let targetY = ((limitY <= placeholder.scrollYToBeVisible) ? limitY : placeholder.scrollYToBeVisible)
                let targetX = ((limitX <= placeholder.scrollXToBeVisible) ? limitX : placeholder.scrollXToBeVisible)

                // do the partial scroll
                that.scrollContainer.scrollTop += ((targetY - that.scrollContainer.scrollTop) / 10)
                that.scrollContainer.scrollLeft += ((targetX - that.scrollContainer.scrollLeft) / 10)

                // cut off the veri small end steps
                if (Math.abs(targetY - that.scrollContainer.scrollTop) < 5) {
                    that.scrollContainer.scrollTop = targetY
                }
                if (Math.abs(targetX - that.scrollContainer.scrollLeft) < 5) {
                    that.scrollContainer.scrollLeft = targetX
                }

                // conditions to continue the recursion
                // check if reached the target positions
                if ((that.scrollContainer.scrollTop !== targetY || that.scrollContainer.scrollLeft !== targetX) &&
                    // check if other scroll not started parallel
                    that.scrollId === scrollId &&
                    // check if te scroll is stuck because shorter available scroll space like what was saved
                    (lastX !== that.scrollContainer.scrollLeft || that.scrollContainer.scrollTop !== lastY)
                ) {
                    // recursive call
                    that.scrollTo(placeholder, scrollId, that.scrollContainer.scrollLeft, that.scrollContainer.scrollTop)
                }

                clearTimeout(timeoutId);
            }
            , 5)
    }

    increaseJumperIndex(placeholder) {
        const { jumpersState } = this.state

        jumpersState[placeholder.stakeholderId] = jumpersState[placeholder.stakeholderId] ? jumpersState[placeholder.stakeholderId]+1 : 1

        this.setState({jumpersState})
    }

    /**
     * Content of are you sure modal
     */
    render() {
        const {dataForEditDocument, stakeholders, style, isOpen, contentLabel, didClose, onCancel, onSave, packageDSDocuments} = this.props
        const {placeholders} = this.state
        if (!dataForEditDocument || !dataForEditDocument.dsDocument) {
            return <div>...</div>
        }

        // for placeholder creator tool
        let dsDocument = dataForEditDocument.dsDocument
        let idForDOMElement = c.DSDOC_PLACEHOLDER_ELEMENT_REF + dsDocument._id
        let pageSizeList = dataForEditDocument.pageSizeList
        let maxPageNumber = dataForEditDocument.maxPageNumber
        let totalNumberOfSigners = stakeholders.length

        // update doc instance from the state
        dsDocument = findDocumentFromListById(dsDocument._id, packageDSDocuments)

        let docLang = nesProp.get(dsDocument, "language")
        let langIndex = ((docLang === 'nl') ? 0 : (docLang === 'fr' ? 1 : 2))
        let popupTitle = nesProp.get(dsDocument, "documentTemplate.title." + (docLang || 'nl'))
        // Do not check max number of signer placeholder because of BEWB-743 (vwrsion 8.2 recuirement)!!!
        let placeholderCountIsFull = false //!!(stakeholders.length <= placeholders.length)

        let placeholdersMap = {}
        placeholders.forEach((placeholder) => {
            // init
            placeholdersMap[placeholder.stakeholderId] =
                placeholdersMap[placeholder.stakeholderId] ?
                placeholdersMap[placeholder.stakeholderId] :
                []

            placeholdersMap[placeholder.stakeholderId].push(placeholder)
        })


        return (
            <Modal
                isOpen={isOpen}
                style={style}
                contentLabel={contentLabel}
                key={"PlaceholderComposerModalKey"}
            >
                <div
                    className={cs(stylesDocCss.documentsModalContent, stylesDocCss.maximizeModalContent)}
                    key={dsDocument._id+Math.random()}
                    id="templateHolderDiv"
                >
                    <span className={stylesDocCss.title}>
                        {_('fillDocumentModalTitle') + " - " + popupTitle}
                    </span>
                            <div className={cs(stylesDocCss.formInputContainer, stylesDocCss.titleLabel)}
                                key="selectSignaturePlaceholderDocumentModalContentTitleKey">
                                {_('selectSignaturePlaceholderModalContent')}
                            </div>
                            <div
                                key="documentImagesMainContainerKey"
                                className={stylesDocCss.documentImagesMainContainer}
                            >
                                <div
                                    key="selectSignaturePlaceholderOnImageList_MainContainerKey"
                                    className={stylesDocCss.imageListContainer}
                                    width="100%"
                                    id={c.DSDOC_PLACEHOLDER_ELEMENT_REF + dsDocument._id}

                                    ref={(ref) => this.setScrollContainerRef(ref)}
                                    onScroll={(e) => this.handleScroll(e)}

                                    onMouseMove={(e) => {
                                        if (this.signaturePlaceholderSelector) {
                                            this.signaturePlaceholderSelector.containerOnMouseMove(e)
                                        }
                                    }}
                                    onMouseUp={(e) => {
                                        // event must persist until the call stack will be empty and the callback queue will run
                                        e.persist()

                                        // wait to flush the react vDOM to the browsers DOM
                                        let timeoutId = setTimeout(() => {
                                            if (this.signaturePlaceholderSelector) {
                                                this.signaturePlaceholderSelector.containerOnMouseUp(e)
                                            }

                                            clearTimeout(timeoutId)
                                        }, 0)
                                    }}
                                    onClick={(e) => {
                                        // event must persist until the call stack will be empty and the callback queue will run
                                        e.persist()

                                        // wait to flush the react vDOM to the browsers DOM
                                        let timeoutId = setTimeout(() => {
                                            if (this.signaturePlaceholderSelector) {
                                                this.signaturePlaceholderSelector.containerOnClick(e)
                                            }

                                            clearTimeout(timeoutId)
                                        }, 0)
                                    }}
                                >
                                    <DynamicImageListComponent
                                        documentId={dsDocument._id}
                                        maxPageNumber={maxPageNumber}
                                        pageDistances={PAGE_DISTANCES}
                                        handleScroll={(detail, view) => this.handleScroll(detail, view)}
                                    />

                                    {placeholders && placeholders.map((placeholder) => this.renderPlaceholder(placeholder, placeholders, stakeholders))}

                                </div>
                            </div>
                        <div className={stylesPHolder.placeholdersModalButtons}>
                            <div key="jumpHolders" className={stylesPHolder.jumpButtonsHolder}>
                                <div key={"jumpToText"}  className={stylesPHolder.jumpButtonsLabel}>
                                    {(placeholders && placeholders.length) ? _('jumpToPlaceholder') : ""}
                                </div>
                                {placeholders &&
                                    placeholders.map((placeholder) => this.renderPlaceholderJumpers(placeholder, placeholdersMap))
                                }
                            </div>
                            <div
                                className={stylesPHolder.greenButton + (placeholderCountIsFull ? " disabled" : "")}
                                disabled={placeholderCountIsFull}
                                onClick={()=>{
                                    // abort if all of the placeholders are added
                                    if (placeholderCountIsFull) {
                                        return
                                    }

                                    // add new placeholder
                                    this.startSelectCoordinate()
                                }}
                            >
                                {"+" + _("addSignaturePlaceholder")}
                            </div>
                            <div
                                onClick={()=>{
                                    this.scrollPositionX = 0
                                    this.scrollPositionY = 0
                                    this.signaturePlaceholderSelector && this.signaturePlaceholderSelector.deleteAllPlaceholders()

                                    onCancel()
                                    didClose()
                                }}
                                className={stylesPHolder.cancel}
                            >
                                {_("cancel")}
                            </div>
                            <div
                                onClick={(e)=>{
                                    let that = this
                                    this.saveDocumentPlaceholders(dsDocument, totalNumberOfSigners)
                                    .then((updatedDocument) => {
                                        that.scrollPositionX = 0
                                        that.scrollPositionY = 0
                                        that.signaturePlaceholderSelector.deleteAllPlaceholders()
                                        didClose(updatedDocument)
                                    })
                                    .catch((err) => {
                                        that.scrollPositionX = 0
                                        that.scrollPositionY = 0
                                        that.signaturePlaceholderSelector.deleteAllPlaceholders()
                                        console.error(err)
                                        didClose(err.error)
                                    })

                                }}
                                className={stylesDocCss.greenButton + " enabled"}
                            >
                                {_("save")}
                            </div>
                        </div>
                </div>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/handleSignaturePlaceholders/popupOfSignaturePlaceholder.jsx